import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.package',

            formatted: {
                tangible: 'Tangible (Producto físico)',
                intangible: 'Intangible (Servicio)'
            },

            types: [
                'tangible',
                'intangible'
            ]
        }
    },

    methods: {
        getNew() {
            return {
                type: 'tangible',
                weight: 1,
                height: 1,
                width: 1,
                length: 1
            }
        }
    }
}